import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__grid">
          <div className="footer__col">
            <div className="footer__brand">
              <span className="footer__brand-name">EPIC</span>
              <span className="footer__brand-sub">HAIR SALON</span>
            </div>
            <p className="footer__tagline">
              Where beauty meets expertise. Serving Chesterfield, Michigan with over 36 years of experience.
            </p>
            <a
              href="https://www.instagram.com/beautybybrenita"
              target="_blank"
              rel="noopener noreferrer"
              className="footer__social-link"
            >
              Instagram @beautybybrenita
            </a>
          </div>

          <div className="footer__col">
            <h4 className="footer__heading">Quick Links</h4>
            <ul className="footer__links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li>
                <a href="https://epichairsalon.glossgenius.com/services" target="_blank" rel="noopener noreferrer">
                  Book Online
                </a>
              </li>
            </ul>
          </div>

          <div className="footer__col">
            <h4 className="footer__heading">Contact Info</h4>
            <div className="footer__contact-item">
              <span className="footer__contact-label">Address</span>
              <span>49134 Gratiot Ave</span>
              <span>Chesterfield, MI 48051</span>
            </div>
            <div className="footer__contact-item">
              <span className="footer__contact-label">Phone</span>
              <a href="tel:5869493955">(586) 949-3955</a>
            </div>
            <div className="footer__contact-item">
              <span className="footer__contact-label">Hours</span>
              <span>Tue-Wed: 9 AM - 5 PM</span>
              <span>Thu-Fri: 9 AM - 8 PM</span>
              <span>Sat: 8 AM - 1 PM</span>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <p>&copy; {new Date().getFullYear()} Epic Hair Salon. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
